'use client';

import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  gap: 48px;

  ${({ $type }) =>
    $type === 'card' &&
    css`
      display: grid;
      justify-items: center;
      grid-template-columns: repeat(4, 1fr);

      max-width: 1158px;
      margin: 0 auto;
      gap: 18px;

      @media (max-width: 1320px) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media (max-width: 936px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 618px) {
        grid-template-columns: repeat(1, 1fr);
      }
    `}
`;
